import { Navigate } from 'react-router-dom'
import { ROUTES } from '@/config/routes'
import { useCurrentUser } from '@/features/auth/state/auth'
import { hasUserAddress } from '@/features/auth/utils/has-user-address'

const MinutaUserRoute = ({ children }: { children: JSX.Element }) => {
  const user = useCurrentUser()
  console.log(user)
  if (!user) {
    return <Navigate to={ROUTES.SIGNIN.path} />
  }
  if (!hasUserAddress(user)) {
    return <Navigate to={ROUTES.CEP.path} />
  }

  return children
}

export default MinutaUserRoute
